import { createContext } from "react"

export type VideoFitMode = "fit" | "fill"

/**
 * The fit mode a tile starts in, chosen by the layout it is drawn in.
 *
 * A tile's own menu still switches between Fit and Fill; this only decides
 * where it starts. Most layouts start in Fit so a tile of an unusual shape
 * shows the whole camera frame. The stage rails (whiteboard, screen share,
 * document, video share, sidebar, pinned) are designed with tiles that fill
 * their rows, and a filled row shows the camera edge to edge — so they start
 * in Fill, as the design does.
 */
export const VideoFitDefaultContext = createContext<VideoFitMode>("fit")
